import React from 'react'
import { IIconBullet } from './IconBullet.types'
import ParrotfishIcon, { IParrotfishIcon } from '../../ParrotfishIcon'

// MUI
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'

const styles = {
  root: {
    padding: '0 0 36px 0',
  },
  icon: {
    height: '36px',
    width: '36px',
  },
}

const IconBullet = ({ title, description, icon }: IIconBullet) => {
  return (
    <ListItem sx={styles.root}>
      <ListItemAvatar>
        <ParrotfishIcon {...(icon as IParrotfishIcon)} sx={styles.icon} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant="subtitle1" component="h3">
            {title}
          </Typography>
        }
        secondary={<Typography variant="caption">{description}</Typography>}
      />
    </ListItem>
  )
}

export default IconBullet
